import { render, staticRenderFns } from "./WorksListItemExpanded.vue?vue&type=template&id=2b059150&"
import script from "./WorksListItemExpanded.vue?vue&type=script&lang=js&"
export * from "./WorksListItemExpanded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports